import React from 'react';
import { Helmet } from 'react-helmet';

import { ReactComponent as OpusBasicsIcon } from '../../icons/resources/icon-opus-basics.svg';
import { ReactComponent as GlossaryIcon } from '../../icons/resources/icon-glossary.svg';
import { ReactComponent as FAQIcon } from '../../icons/resources/icon-faq.svg';
import { ReactComponent as TrainingVideoIcon } from '../../icons/resources/icon-training-video.svg';
import { ReactComponent as PopularPlaylistIcon } from '../../icons/resources/icon-popular-playlist.svg';
import { ReactComponent as ContactUsIcon } from '../../icons/resources/icon-contact-us.svg';

import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import Footer from 'components/Footer/Footer';
import BackToTop from 'components/BackToTop/BackToTop';
import HelpHeader from 'components/Help/HelpHeader';
import MoreResources from 'components/Help/MoreResources/MoreResources';
import ResourcesWrapper from 'components/Help/ResourcesWrapper';

import useMedia from 'hooks/useMedia';

import ResourceItemCard, {
  IResourceItemCard,
} from 'components/Help/ResourceItemCard/ResourceItemCard';
import { Divider, Main, Box } from './Help.style';

const Help: React.FC = () => {
  const isLargeScreen = useMedia('(min-width: 60em)');
  const isSmallScreen = useMedia('(max-width: 40em)');

  const resources: IResourceItemCard[] = [
    {
      label: 'Opus Basics',
      Icon: OpusBasicsIcon,
      isTargetBlank: true,
      href: 'https://wmg.sharepoint.com/sites/Opus/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FOpus%2FShared%20Documents%2FOpus%20Course%201%20%2D%20Opus%20Basics%2Epdf&parent=%2Fsites%2FOpus%2FShared%20Documents',
    },
    {
      label: 'Glossary',
      Icon: GlossaryIcon,
      href: '/glossary',
    },
    {
      label: 'FAQ',
      Icon: FAQIcon,
      href: '/faq',
    },
    {
      label: 'Training Video',
      Icon: TrainingVideoIcon,
      href: '/trainingVideo',
      isTargetBlank: true,
    },
    {
      label: 'Popular Playlist',
      Icon: PopularPlaylistIcon,
      href: '/faqActivityTracker',
      isTargetBlank: true,
    },
    {
      label: 'Contact Us',
      Icon: ContactUsIcon,
      href: '/glossary/general-information/contact',
    },
  ];

  return (
    <>
      <ScrollTopOnMount />
      <Helmet defer={false} title="Opus Help" />

      <HelpHeader />

      <Main>
        <Box isLargeScreen={isLargeScreen}>
          <ResourcesWrapper
            isSmallScreen={isSmallScreen}
            isLargeScreen={isLargeScreen}
          >
            {resources.map((item, idx) => (
              <ResourceItemCard
                key={idx}
                isLargeScreen={isLargeScreen}
                label={item.label}
                Icon={item.Icon}
                href={item.href}
                isTargetBlank={item.isTargetBlank}
              />
            ))}
          </ResourcesWrapper>
          <Divider isSmallScreen={isSmallScreen} />
          <MoreResources isLargeScreen={isLargeScreen} />
        </Box>
      </Main>

      <BackToTop />
      <Footer />
    </>
  );
};

export default Help;
